export class TypeEvent {
  id: number;
  name: string;
  color: string;
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/models/type-event.ts